// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-common-HeaderTabView-HeaderTabView-module__container-DFHDOQ","tab":"src-app-components-common-HeaderTabView-HeaderTabView-module__tab-Q7r2h0","active":"src-app-components-common-HeaderTabView-HeaderTabView-module__active-SI0kwS","tab__cover":"src-app-components-common-HeaderTabView-HeaderTabView-module__tab__cover-GGgl2a","tabCover":"src-app-components-common-HeaderTabView-HeaderTabView-module__tab__cover-GGgl2a","star":"src-app-components-common-HeaderTabView-HeaderTabView-module__star-Yhlzor","close":"src-app-components-common-HeaderTabView-HeaderTabView-module__close-lgj3B5"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-common-HeaderTabView-HeaderTabView-module__container-DFHDOQ\",\"tab\":\"src-app-components-common-HeaderTabView-HeaderTabView-module__tab-Q7r2h0\",\"active\":\"src-app-components-common-HeaderTabView-HeaderTabView-module__active-SI0kwS\",\"tab__cover\":\"src-app-components-common-HeaderTabView-HeaderTabView-module__tab__cover-GGgl2a\",\"tabCover\":\"src-app-components-common-HeaderTabView-HeaderTabView-module__tab__cover-GGgl2a\",\"star\":\"src-app-components-common-HeaderTabView-HeaderTabView-module__star-Yhlzor\",\"close\":\"src-app-components-common-HeaderTabView-HeaderTabView-module__close-lgj3B5\"}";
        // 1789362522825
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  